import React from "react";
import { Row,
    Modal, 
    Button, Spin, 
    Table,
    Col,
    message,
} from "antd";
import { List } from "immutable";
import PropTypes from "prop-types";
import { CaseService, CompanyService } from "../../services";
import { connect } from "react-redux";
import moment from "moment";

class CaseBureauDetails extends React.Component {
    state = {
        cibilHardPullData: [],
        applicant_id: null,
        visibleModalRawHtml: [],
        visibleModal: false,
        showCibilData: false,
        loading: false,
        commercialCibilHardPullData : []
    };

    componentDidMount () {
        CompanyService.getCibilHardPull(this.props.caseId).then(({data})=>{
            this.setState({commercialCibilHardPullData:data,});
        }).catch((err) => {
            console.log( err);
            message.error("Something went wrong");
        });
        CaseService.fetchCaseCibilAllApplicants(this.props.caseId).then(({data})=>{
            this.setState({cibilHardPullData:data,});
        }).catch((err) => {
            console.log( err);
            message.error("Something went wrong");
        });
        this.setState({showCibilData: true});
    }

    showModal = (keyV, el) => {
        const rawHtmlClickedBtn = el && el.all_data && el.all_data[keyV] && el.all_data[keyV].raw_html;
        this.setState({visibleModal: true, visibleModalRawHtml: [rawHtmlClickedBtn]});
    };
   
      handleCancel = () => {
          this.setState({visibleModal: false});
      };

         replaceCss = (renderedHtml) => {
             return  renderedHtml.replace(/(<style[\w\W]+style>)/g, "");
         }

        onSelectApll = (val) => {
            this.setState({applicant_id:val});
        };

        triggerCibil = (val, applicant_id) => {
            const caseId = this.props.caseId;
            this.setState({loading: true});
            const bodyCommercial = {
                case_id: caseId
            };
            if(val == "commercial"){
                CompanyService.triggerCibilHardPull("commercial" , bodyCommercial).then(({ data }) => {
                    if (data && data.message === "success") {
                        message.success("Cibil triggered successfully")
                        CompanyService.getCibilHardPull(caseId).then(({ data }) => {
                            this.setState({ commercialCibilHardPullData: data });
                        }).catch((err) => {
                            message.error("Something went wrong");
                        })
                        this.setState({ showCibilData: true, loading: false })
                    } else {
                        this.setState({ showCibilData: false, loading: false })
                    }
                }).catch((err) => {
                    message.error(err && err[0] || "Something went wrong");
                    this.setState({loading: false});
                })
            } else if (val === "consumer") {
                CaseService.triggerCibilConsumer(caseId, applicant_id).then(({ data }) => {
                    if (data && data.message === "success") {
                        message.success("Cibil triggered successfully");
                        CaseService.fetchCaseCibilAllApplicants(caseId).then(({ data }) => {
                            this.setState({ cibilHardPullData: data, });
                        }).catch((err) => {
                            message.error("Something went wrong");
                        })
                        this.setState({ showCibilData: true, loading: false })
                    } else {
                        this.setState({ showCibilData: false, loading: false } , () => {
                            message.error("Something went wrong");
                        });
                    }
                }).catch((err) => {
                    message.error(err && err[0] || "Something went wrong");
                    this.setState({ loading: false });
                })
            }
        }

         columnsCommercial = [
             {
                 dataIndex: "commercial",
                 key: "commercial",
                 align: "left",
                 width: "30%"
             },
             {
                 dataIndex: "triggerBtnCommercial",
                 key: "triggerBtnCommercial",
                 align: "center",
                 width: "30%",
             }
         ];
          columnsConsumer = [
              {
                  title: <div style={{fontSize:"16px"}}>Consumer</div>,
                  dataIndex: "consumer",
                  key: "consumer",
                  width: "30%",
                  align: "left",
              },
              {
                  dataIndex: "triggerBtnConsumer",
                  key: "triggerBtnConsumer",
                  align: "center",
                  width: "30%",
              },
          ];

          render() {
            const {commercialCibilHardPullData} = this.state;
              const cibilHardPullData = this.state.cibilHardPullData.length>0 && this.state.cibilHardPullData;
              const consumerData = cibilHardPullData && cibilHardPullData.filter(el=>el.bureau_type === 1);
              const commercialData = commercialCibilHardPullData && commercialCibilHardPullData.length  ? commercialCibilHardPullData.filter(el=>el.bureau_type === 2) : [];
              const consumerDataObjId = {};
              const commercialDataObjId = {};
              const commercialCreatedDate = commercialData && commercialData[0] && commercialData[0].created_date;
              {consumerData && consumerData.map(el=>{
                  const consumerId = el.id;
                  el && el.all_data && Object.entries(el.all_data).map(_=>{
                      (consumerDataObjId[`${_[0]}-${consumerId}`]=  _[1]);});
              });}
              {commercialData && commercialData.map(el=>{
                  const commercialId = el.id;
                  el && el.all_data && Object.entries(el.all_data).map(_=>{
                      (commercialDataObjId[`${_[0]}-${commercialId}`]=  _[1]);});
              });}
              const rawHtmlRemovedCss = this.state.visibleModalRawHtml.length>0 && this.replaceCss( this.state.visibleModalRawHtml[0]);
              const {
                  company,
              } = this.props;
              const renderCommercialDataHtml = [
                  {
                      key: 1,
                      commercial: <div style={{width:"max-content"}}><div style={{fontSize:"16px", fontWeight:"500", color:"rgba(0, 0, 0, 0.85)"}}>Commercial</div> 
                          <span>{commercialData && commercialData[0] && `(Last triggered on ${moment(commercialCreatedDate).format("DD-MM-YYYY")})`}</span>
                      </div>,
                      triggerBtnCommercial: <Button size={"large"} type="primary" onClick={() => this.triggerCibil("commercial")}  disabled={this.props.recreditViewOnlyPermission}>
                      Trigger 
                      </Button> 
                  }
              ];
              const renderConsumerDataHtml = [];    
              company && company.toJS().associates && Object.values(company.toJS().associates).length>0 && Object.values(company.toJS().associates).map((_,idx) => {
                  const lastTriggeredOn = consumerData && consumerData.find(el=>el.associate.id === _.id) && consumerData.find(el=>el.associate.id === _.id).created_date;
                  const consumerName =   <div style={{width:"max-content"}}>
                      <div className="cibil-associate-div">{_.first_name} {_.last_name} </div>
                      <span>{lastTriggeredOn && `(Last triggered on ${moment(lastTriggeredOn).format("DD-MM-YYYY")})`}
                      </span></div>;
                  const consumerTriggerBtn = <Button key={_.id} size={"large"} type="primary" onClick={() => this.triggerCibil("consumer", _ && _.id)} disabled={this.props.recreditViewOnlyPermission}>
                Trigger 
                  </Button>; 
                  const consumerEl = {
                      key: idx+1,
                      consumer: consumerName,
                      triggerBtnConsumer: consumerTriggerBtn,
                  };
                  renderConsumerDataHtml.push(consumerEl);
                  return renderConsumerDataHtml;
              });
              return (
                  <Spin spinning={this.state.loading}>
                      <Row className={"p-5"}>
                          <Modal
                              style={{ top: 20 }}
                              width={"90%"}
                              visible={this.state.visibleModal}
                              onCancel={() => this.handleCancel()}
                              footer={null}
                          >
                              <div dangerouslySetInnerHTML={{ __html: rawHtmlRemovedCss }}></div>
                          </Modal>
                          <div className="d-flex flex-column justify-content-center">
                              <div className="d-flex flex-column">
                                  {!this.props.hideCommercialData && <Col span={8} className={"mt-10 p-10"}>
                                      <Table
                                          pagination={false}
                                          showHeader={false}
                                          size={"default"}
                                          bordered
                                          columns={this.columnsCommercial || []}
                                          dataSource={renderCommercialDataHtml || new List([{}])}
                                          align={"center"}
                                          className="table-border"
                                      />
                                  </Col>}
                                  <Col span={8} className={"mt-10 p-10"}>
                                      <Table
                                          pagination={false}
                                          size={"default"}
                                          bordered
                                          columns={this.columnsConsumer || []}
                                          dataSource={renderConsumerDataHtml || new List([{}])}
                                          align={"center"}
                                          className="table-border"
                                      />
                                  </Col>
                              </div>
                              {this.state.showCibilData &&
                                  consumerData ?
                                  <div className="d-flex flex-column">
                                      {commercialData.length > 0 ? <Col span={24} className={"mt-20 mb-20 cibil-associates-div"}>
                                          <div className="d-flex flex-row justify-content-space-between w-100" style={{ padding: "0 2.2rem 0 0.8rem" }}>
                                              <p style={{ fontSize: "16px", fontWeight: "500", color: "black" }} level={2}>Commercial</p>
                                              <a
                                                  href={commercialData.length > 0 && commercialData[0].file_url}
                                                  size={"large"} type="primary">
                                                  <Button size={"large"} icon={"download"} type="primary" >Download</Button>
                                              </a>
                                          </div>
                                          <div className="d-flex flex-row flex-wrap">
                                              {commercialData.length > 0 && commercialData[0].all_data && Object.keys(commercialData[0].all_data).length > 0 && Object.keys(commercialData[0].all_data).map((el, idx) => {
                                                  return (
                                                      <Button key={idx} size={"large"} style={{ margin: "10px", fontSize: "12px", width: "260px", whiteSpace: "pre-line" }} onClick={() => this.showModal(el, commercialData[0])}>
                                                          {commercialData.length > 0 && commercialData[0].all_data && commercialData[0].all_data[el] && commercialData[0].all_data[el].label}
                                                      </Button>
                                                  );
                                              })}
                                          </div>
                                      </Col> : null}
                                      {/* <Col span={24} className={"mb-10"}>
                                              <div className="d-flex flex-column  align-items-center cibil-associates-div">
                                                  <div className="d-flex flex-row justify-content-space-between w-100" style={{padding: "0 2.2rem 0 0.8rem"}}>
                                                      <p style={{fontSize:"16px", fontWeight:"500", color:"black"}} level={2}>Consumer</p>
                                                  </div>
                                                  <div className="d-flex flex-row flex-wrap">
                                                      {consumerData && consumerData.map((el, idx)=>{
                                                          return(
                                                              <div key={idx} className="mb-20">
                                                                  <div className="d-flex flex-row justify-content-space-between w-100"  style={{padding: "0 0.8rem"}}>
                                                                      <p className="cibil-associate-div">
                                                                          {el?.associate?.name}
                                                                      </p >
                                                                      <a href={el && el.file_url} size={"large"}>
                                                                          <Button size={"large"} icon={"download"} type="primary" 
                                                                          >
                                                              Download</Button>
                                                                      </a> 
                                                                  </div>
                                                                  {Object.keys(el.all_data).map((ele,idx)=>{
                                                                      return(
                                                                          <Button key={idx} size={"large"} style={{ margin:"10px", fontSize:"12px", width:"260px", whiteSpace:"pre-line"}}onClick={() => this.showModal(ele, el)}>
                                                                              {el.all_data[ele].label}
                                                                          </Button>
                                                                      );})}
                                                              </div>
                                                          );})}
                                                  </div>
                                              </div>
                                          </Col> */}
                                  </div>
                                  : null
                              }
                          </div>
                      </Row>
                  </Spin>
              );
          }
}

CaseBureauDetails.propTypes = {
    caseDetailStatus: PropTypes.string,
    companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    company: PropTypes.object,
    caseId: PropTypes.number,
    permissionContext: PropTypes.object,
    isUserAllowedToEdit: PropTypes.bool,
    current_case_task: PropTypes.object,
    user: PropTypes.object,
    recreditViewOnlyPermission: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    const current_case_task = state.caseDetails &&
       state.caseDetails.getIn([Number(props.caseId), "status"]) === "FETCHED" &&
       state.caseDetails.getIn([Number(props.caseId), "data"]);
    return{
        company: state.companies.getIn([props.companyId, "data"]),
        current_case_task: current_case_task,
        user: state.user.get("data"),
    };};


export default connect(
    mapStateToProps,
)(CaseBureauDetails);